import { useDispatch, useSelector } from "react-redux";
import "../../css/light.css"
import "../../css/dark.css"
import "../../css/auth.css"
import { useEffect } from "react";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";

const Mode = ({ children }) => {
    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()

    const dark_style = {
        background: "#0F1214",
        width: '100%',
        minHeight: '100dvh'
    }

    const light_style = {
        background: "white",
        width: '100%',
        minHeight: '100dvh'
    }

    useEffect(() => {
        const mode_storage = cookies.getCookies("mode")
        if (mode_storage) {
            const obj = {
                dark: mode_storage === "dark" ? true : false
            }
            dispatch(updatedarkmode(obj))
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className="mode" style={mode.dark ? dark_style : light_style}>
            <div className={mode.dark ? "dark-mode" : "light-mode"}>
                {children}
            </div>
        </div>
    );
}

export default Mode;